module.exports = __webpack_public_path__ + "img/round-arrow-right.a440623f.svg";